var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f3dc7d5ae76df23cf0eb643bb5a2c6b1282a09e5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breitbart-nextjs-web@sentry"]={id:"f3dc7d5ae76df23cf0eb643bb5a2c6b1282a09e5"};
      